import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Box from "@mui/material/Box";
import { connect, useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import HistoryIcon from "@mui/icons-material/History";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SmsIcon from "@mui/icons-material/Sms";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import { MenuItem, MenuList, Tab, Tabs, tabsClasses, Tooltip } from "@mui/material";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { useLocation } from "react-router";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import { t, tl } from "../../../components/translate";
import ClientShow from "../ClientShow";
import * as clientActions from "../../../actions/client";
import * as VitalActions from "../../../actions/vitals";
import ClientVisits from "./ClientVisits";
import ClientBills from "./ClientBills";
import ClientLabs from "./ClientLabs";
import Panel from "../../../components/Panel";
import Trainings from "../Training/Trainings";
import Authorize from "../../../auth/authorization";
import { navigateRemoveModal, showDialog } from "../../../actions/navigation";
import { clientFullNameSelector } from "../../../reducers/client";
import ClientAssessments from "./ClientAssessments";
import VitalsPopUp from "../../Assessment/Vitals/VitalsPopUp";
import ClientVitals from "./ClientVitals";
import localStorage from "../../../helpers/localStorage";
import RecordPayment from "../../Billing/RecordPayment/RecordRefundPayment";
import MessageCreate, {
  MessageType,
  MESSAGE_TYPE
} from "../../Campaign/InstantMessage/MessageCreate";
import { IUser } from "../../../interfaces/User";
import ClientLedger from "./ClientLedger";
import { AppDispatch, IThunkDispatch, RootState } from "../../../store";
import { Client, ClientVisit } from "../../../interfaces/ClientInterface";
import Can from "../../Policy/Can";
import EstimatesCreateEdit from "../Estimates/EstimatesCreateEdit";
import EstimateInfo from "../Estimates/EstimateInfo";
import EstimateList from "../Estimates/EstimateList";
import { fetchEstimatesByClient, fetchEstimateTemplate } from "../../../slices/estiamtesSlice";
import { notificationAdd } from "../../../actions/notification";
import {
  errorFetchMessage,
  MODULE,
  MessageTemplateEnum,
  getMessageTemplate
} from "../../../helpers/messages";
import ClientActivity from "./ClientActivity";
import ConsentCreateEditForm, { ConsentData } from "../Consent/ConsentCreateEditForm";
import ConsentFormShow from "../Consent/ConsentFormShow";
import ConsentFormList from "../Consent/ConsentFormList";
import { Estimate } from "../Estimates/interfaces";
import SurveyCreateEditForm, { SurveyData } from "../Survey/SurveyCreateEditForm";
import SurveyFormShow from "../Survey/SurveyFormShow";
import SurveyFormList from "../Survey/SurveyFormList";
import { getSurveyFormTemplate } from "../../../api/surveyForm";
import { defaultTemplateDocument } from "../../ResourceCentre/OtherSettings/SurveyFormSettings";
import { ClientStickerPrinter } from "../Sticker/ClientStickerPrinter";

import { deleteClient } from "../../../actions/client";
import FingerprintEnrollPanel from "../FingerprintEnrollPanel";
import OkhatiDialog from "../../../components/Dialog/Dialog";
import { agentDelete, deleteFingerprintTemplateById } from "../../../api/fingerprintTemplates";
import useSyncClient from "../../../hooks/useSyncClient";

import useModuleSubscriptions from "../../../hooks/useModuleSubscriptions";
import ClientCheckInOut from "./ClientCheckInOut";

const TABS = {
  VISITS: "visits",
  BILLS: "bills",
  ASSESSMENTS: "assessments",
  VITALS: "vitals",
  LABS: "labs",
  LEDGER: "ledger",
  ESTIMATES: "estimates",
  CONSENT_FORM: "consent_form",
  SURVEY_FORM: "survey_form",
  TRAININGS: "trainings"
} as const;

type TabType = (typeof TABS)[keyof typeof TABS];

type Props = MapDispatchToProps & MapStateToProps & OwnProps;

const ClientInfo: React.FC<Props> = ({
  navigateTo,
  getClientVisits,
  clientData = undefined,
  user,
  onDeleteClient,
  handleViewClose,
  postVitals,
  getVitals,
  loadFullClient,
  restrictTestCreation,
  wrapperStyle = {},
  setEditMode,
  stayOnCurrentPage = false,
  id,
  permissionGroup,
  messageTemplateType,
  labResultUrl
}) => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();

  // custom hooks
  const { isOpdSubscribed } = useModuleSubscriptions();

  // ref
  const anchorRef = React.useRef<HTMLDivElement>(null);

  // selectors
  const activeRc = useSelector((state: RootState) => state.userContext.resourceCentre);

  const [activeTab, setActiveTab] = useState<TabType>(TABS.VISITS);
  const [openMenu, setOpenMenu] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showMessagePanel, setShowMessagePanel] = useState(false);
  const [isVitalPopupOpen, setIsVitalPopupOpen] = useState(false);
  const [showActivityPanel, setShowActivityPanel] = useState(false);
  const [messageType, setMessageType] = useState<MessageType>(MESSAGE_TYPE.SMS);
  const [showFingerPrintPanel, setShowFingerPrintPanel] = useState(false);

  const [recordPayment, setRecordPayment] = useState({
    open: false,
    refundMode: false
  });

  const [openFpRemoveDialog, setOpenFpRemoveDialog] = useState(false);
  const { syncClient } = useSyncClient();
  const [estimatePanel, setEstimatePanel] = useState<{ show: boolean; data: Estimate | null }>({
    show: false,
    data: null
  });

  const [surveyTemplate, setSurveyTemplate] = useState<Partial<SurveyData>>({
    document: defaultTemplateDocument
  });

  const [consentForm, setConsentForm] = useState<{
    data: ConsentData | null;
    isOpen: boolean;
    isEditMode: boolean;
  }>({
    isOpen: false,
    isEditMode: false,
    data: null
  });

  const [surveyForm, setSurveyForm] = useState<{
    data: SurveyData | null;
    isOpen: boolean;
    isEditMode: boolean;
  }>({
    isOpen: false,
    isEditMode: false,
    data: null
  });

  // functions
  const handleToggle = () => {
    setOpenMenu((prevOpen) => !prevOpen);
  };

  const navigateToAssessment = (cid: number) => {
    navigateTo(`/assessment/new?clientId=${cid}`);
  };

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }
    setOpenMenu(false);
  };

  // effects
  useEffect(() => {
    if (!clientData) {
      loadFullClient(id);
    }
    getClientVisits(id);
  }, [id]);

  useEffect(() => {
    (async () => {
      try {
        await dispatch(fetchEstimateTemplate()).unwrap();
      } catch (e) {
        dispatch(
          notificationAdd({
            id: new Date().getTime(),
            message: errorFetchMessage(MODULE.ESTIMATES),
            variant: "error",
            autoTimeout: true
          })
        );
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const response = await getSurveyFormTemplate();
        if (response) {
          setSurveyTemplate(response);
        }
      } catch (e) {
        dispatch(
          notificationAdd({
            id: new Date().getTime(),
            message: errorFetchMessage(MODULE.SURVERY_FORM_TEMPLATE),
            variant: "error",
            autoTimeout: true
          })
        );
      }
    })();
  }, []);

  let editButton = null;
  let deleteButton = null;
  let messageButton = null;
  let genericButton = null;

  if (!clientData) return null;

  if (Authorize(user).can("admin", "Patient", { id: clientData.id })) {
    if (!clientData.isWalkInCustomer) {
      genericButton = (
        <Tooltip
          title="Client Activity"
          aria-label="edit"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <HistoryIcon
            data-testmation="clientActivityButton"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setShowActivityPanel(true);
            }}
          />
        </Tooltip>
      );

      editButton = (
        <Tooltip title="Edit" aria-label="edit" sx={{ display: "flex", alignItems: "center" }}>
          <EditIcon
            data-testmation="editButton"
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (!stayOnCurrentPage) {
                navigateTo(`/clients/${clientData.id}/edit${location.search || ""}`);
              }
              if (clientData.active && setEditMode) {
                setEditMode(true);
              }
            }}
          />
        </Tooltip>
      );

      deleteButton = (
        <Tooltip title="Delete" aria-label="delete" sx={{ display: "flex", alignItems: "center" }}>
          <DeleteIcon
            data-testmation="deleteButton"
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (clientData.active) {
                onDeleteClient(
                  clientData.id,
                  clientFullNameSelector(clientData),
                  location.search || ""
                );
              }
            }}
          />
        </Tooltip>
      );

      messageButton =
        clientData?.phone || clientData?.email ? (
          <Box display="flex" alignItems="center" gap={2}>
            {clientData.phone && (
              <Tooltip title="SMS" aria-label="message">
                <SmsIcon
                  data-testmation="smsButton"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setMessageType(MESSAGE_TYPE.SMS);
                    setShowMessagePanel(true);
                  }}
                />
              </Tooltip>
            )}

            {clientData.email && (
              <Tooltip title="Email" aria-label="email">
                <ForwardToInboxIcon
                  data-testmation="emailButton"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setMessageType(MESSAGE_TYPE.EMAIL);
                    setShowMessagePanel(true);
                  }}
                />
              </Tooltip>
            )}
          </Box>
        ) : null;
    }
  }

  return (
    <>
      <Panel
        title="Client Details"
        wrapperStyle={wrapperStyle}
        onClose={handleViewClose}
        editButton={editButton}
        deleteButton={deleteButton}
        genericButton={genericButton}
        messageButton={messageButton}
        contentStyle={{
          py: 0,
          height: "calc(100vh - 50px)"
        }}
      >
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            borderLeft: 1,
            borderRight: 1,
            borderColor: "divider"
          }}
        >
          {clientData?.id && (
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                flexWrap: "wrap",
                px: 2,
                py: 1.25
              }}
            >
              <ClientStickerPrinter clientId={clientData.id} />
            </Box>
          )}

          <Box sx={{ px: 2 }}>
            <ClientShow
              client={clientData}
              showActionbar={false}
              onMessageBtnClick={(mType: MessageType) => {
                setMessageType(mType);
                setShowMessagePanel(true);
              }}
            />
          </Box>

          <Box sx={{ px: 2, mb: 2 }}>
            {permissionGroup !== "resourceCentreCampaignOnlyEmployee" && (
              <Can policyAccessKey="allow" superAdminAgentPassReverse>
                {!clientData.isLead ? (
                  <ButtonGroup
                    size="small"
                    variant="outlined"
                    color="primary"
                    ref={anchorRef}
                    aria-label="split button"
                  >
                    <Button
                      data-testmation="createAssessment"
                      variant="outlined"
                      onClick={() => {
                        localStorage.setItem("patientId", clientData.id?.toString());
                        navigateToAssessment(clientData.id);
                      }}
                      disabled={!isOpdSubscribed}
                      color="primary"
                    >
                      {tl("assessment.createAssessment")}
                    </Button>
                    <Button
                      data-testmation="clientinfoDropdown"
                      size="small"
                      color="primary"
                      aria-owns={openMenu ? "menu-list-grow" : undefined}
                      aria-haspopup="true"
                      onClick={handleToggle}
                    >
                      <ArrowDropDownIcon />
                    </Button>
                  </ButtonGroup>
                ) : (
                  <Button
                    variant="outlined"
                    onClick={() => {
                      navigateTo(`/billing/new?clientId=${clientData.id}`);
                    }}
                    color="primary"
                  >
                    {tl("client.createBill")}
                  </Button>
                )}
              </Can>
            )}

            {clientData?.fingerprintTemplate?.id ? (
              <Button
                onClick={() => setOpenFpRemoveDialog(true)}
                color="error"
                variant="outlined"
                startIcon={<FingerprintIcon />}
                size="small"
                sx={{ mx: 2 }}
              >
                Remove Fingerprint
              </Button>
            ) : (
              <Button
                onClick={() => setShowFingerPrintPanel(true)}
                variant="outlined"
                startIcon={<FingerprintIcon />}
                size="small"
                sx={{ mx: 2 }}
              >
                Enroll Fingerprint
              </Button>
            )}

            <ClientCheckInOut clientId={clientData.id} />

            <Popper
              style={{ zIndex: 1 }}
              open={openMenu}
              anchorEl={anchorRef.current}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...TransitionProps}
                  style={{
                    transformOrigin: placement === "bottom" ? "right bottom" : "right bottom"
                  }}
                >
                  <Paper id="menu-list-grow">
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList>
                        <MenuItem
                          data-testmation="clientBillCreate"
                          onClick={() => {
                            navigateTo(`/calendar/?clientId=${clientData.id}`);
                          }}
                          color="primary"
                        >
                          {tl("booking.createBooking")}
                        </MenuItem>
                        <MenuItem
                          data-testmation="vitals"
                          onClick={() => {
                            setIsVitalPopupOpen(true);
                          }}
                          color="primary"
                          style={{ minWidth: "200px" }}
                        >
                          {tl("assessment.addVitals")}
                        </MenuItem>
                        {!restrictTestCreation && (
                          <>
                            <MenuItem
                              data-testmation="clientLabCreate"
                              onClick={() => {
                                navigateTo(`/lab/labRecords/all/create?cId=${clientData.id}`);
                              }}
                              color="primary"
                              style={{ minWidth: "200px" }}
                            >
                              {tl("client.createLabTest")}
                            </MenuItem>

                            <MenuItem
                              data-testmation="clientMedicalReportCreate"
                              onClick={() => {
                                navigateTo(`/medical/create?cId=${clientData.id}`);
                              }}
                              color="primary"
                              style={{ minWidth: "200px" }}
                            >
                              {tl("client.createMedicalReport")}
                            </MenuItem>
                          </>
                        )}
                        <MenuItem
                          data-testmation="clientBillCreate"
                          onClick={() => {
                            navigateTo(`/billing/new?clientId=${clientData.id}`);
                          }}
                          color="primary"
                          style={{ minWidth: "200px" }}
                        >
                          {tl("client.createBill")}
                        </MenuItem>
                        <MenuItem
                          data-testmation="clientBillCreate"
                          onClick={(e) => {
                            handleClose(e as unknown as MouseEvent);
                            setRecordPayment({ ...recordPayment, open: true });
                          }}
                          color="primary"
                          style={{ minWidth: "200px" }}
                        >
                          {tl("client.recordReceipt")}
                        </MenuItem>
                        <MenuItem
                          data-testmation="clientBillCreate"
                          onClick={(e) => {
                            handleClose(e as unknown as MouseEvent);
                            setRecordPayment({ refundMode: true, open: true });
                          }}
                          color="primary"
                          style={{ minWidth: "200px" }}
                        >
                          {tl("client.createRefund")}
                        </MenuItem>
                        <MenuItem
                          data-testmation="estimateCreate"
                          onClick={(e) => {
                            handleClose(e as unknown as MouseEvent);
                            setEstimatePanel((prevState) => ({ ...prevState, show: true }));
                          }}
                          color="primary"
                        >
                          {tl("estimates.create")}
                        </MenuItem>
                        <MenuItem
                          data-testmation="consentCreate"
                          onClick={(e) => {
                            handleClose(e as unknown as MouseEvent);
                            setConsentForm({ data: null, isOpen: true, isEditMode: false });
                          }}
                        >
                          {tl("consent.create")}
                        </MenuItem>
                        <MenuItem
                          data-testmation="surveyCreate"
                          onClick={(e) => {
                            handleClose(e as unknown as MouseEvent);
                            setSurveyForm({ data: null, isOpen: true, isEditMode: false });
                          }}
                        >
                          {tl("survey.create")}
                        </MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Box>

          {!clientData.isLead && (
            <Can policyAccessKey="allow" superAdminAgentPassReverse>
              <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                {/* tabs */}
                <Tabs
                  value={activeTab}
                  onChange={(e, tab) => setActiveTab(tab)}
                  aria-label="client info tabs"
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  sx={{
                    borderBottom: 1,
                    borderTop: 1,
                    borderColor: "divider",
                    width: "100%",
                    [`& .${tabsClasses.scrollButtons}`]: {
                      "&.Mui-disabled": {
                        display: "none"
                      }
                    },
                    "& .MuiTabs-scroller": {
                      overflowX: "auto !important"
                    },
                    "& .MuiTab-root": {
                      whiteSpace: "nowrap"
                    }
                  }}
                >
                  <Tab label={t("clients.Visits")} value={TABS.VISITS} />
                  <Tab label={t("clients.bills")} value={TABS.BILLS} />
                  <Tab label={t("clients.assessments")} value={TABS.ASSESSMENTS} />
                  <Tab
                    data-testmation="showVitals"
                    label={t("clients.vitals")}
                    value={TABS.VITALS}
                  />
                  <Tab label="Labs" value={TABS.LABS} />
                  <Tab label="Ledger" value={TABS.LEDGER} />
                  <Tab label="Estimates" data-testmation="estimatesTab" value={TABS.ESTIMATES} />
                  <Tab
                    label={t("consent.form")}
                    data-testmation="consentFormTab"
                    value={TABS.CONSENT_FORM}
                  />
                  <Tab
                    label={t("survey.form")}
                    data-testmation="surveyFormTab"
                    value={TABS.SURVEY_FORM}
                  />
                  <Tab
                    label={t("clients.trainings")}
                    data-testmation="trainingsTab"
                    value={TABS.TRAININGS}
                  />
                </Tabs>

                {/* tab contents */}
                <Box sx={{ flex: 1 }}>
                  {activeTab === TABS.VISITS && <ClientVisits clientId={clientData.id} />}
                  {activeTab === TABS.BILLS && (
                    <ClientBills clientId={clientData.id} shouldFetchBills={recordPayment.open} />
                  )}
                  {activeTab === TABS.ASSESSMENTS && (
                    <ClientAssessments clientId={clientData.id} clientData={clientData} />
                  )}
                  {activeTab === TABS.VITALS && <ClientVitals clientId={clientData.id} />}
                  {activeTab === TABS.LABS && <ClientLabs clientId={clientData.id} />}
                  {activeTab === TABS.LEDGER && <ClientLedger clientId={clientData.id} />}
                  {activeTab === TABS.ESTIMATES && (
                    <EstimateList
                      clientId={clientData.id}
                      onRowClick={(data: Estimate) =>
                        setEstimatePanel((prevState) => ({ ...prevState, data }))
                      }
                    />
                  )}
                  {activeTab === TABS.CONSENT_FORM && (
                    <ConsentFormList
                      clientId={clientData.id}
                      onRowClick={(data: ConsentData) =>
                        setConsentForm((prev) => ({ ...prev, data }))
                      }
                    />
                  )}
                  {activeTab === TABS.SURVEY_FORM && (
                    <SurveyFormList
                      clientId={clientData.id}
                      onRowClick={(data: SurveyData) =>
                        setSurveyForm((prev) => ({ ...prev, data }))
                      }
                    />
                  )}
                  {activeTab === TABS.TRAININGS && <Trainings clientData={clientData} />}
                </Box>
              </Box>
            </Can>
          )}
        </Box>
      </Panel>

      {/* dialogs, popups and panels */}
      <VitalsPopUp
        isOpen={isVitalPopupOpen}
        onClose={() => {
          setIsVitalPopupOpen(false);
          if (setEditMode) {
            setEditMode(false);
          }
        }}
        onSave={async (vitals) => {
          if (setEditMode) {
            setEditMode(false);
          }
          await postVitals(vitals, clientData.id);
          await getVitals(clientData.id);
        }}
      />

      {recordPayment.open ? (
        <Box>
          <RecordPayment
            clientId={clientData.id}
            onClose={() => {
              setRecordPayment({ open: false, refundMode: false });
            }}
            refundMode={recordPayment.refundMode}
          />
        </Box>
      ) : null}

      {showMessagePanel && (
        <MessageCreate
          onCancel={() => {
            setShowMessagePanel(false);
          }}
          client={clientData}
          messageType={messageType}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...(messageTemplateType && {
            defaultSubject: getMessageTemplate({
              messageTemplateType
            }).subject,
            initialHTMLMessage: getMessageTemplate({
              messageTemplateType,
              activeRc,
              labResultUrl: labResultUrl || "",
              client: clientData
            }).emailBody,
            defaultSmsBody: getMessageTemplate({
              messageTemplateType,
              activeRc,
              labResultUrl: labResultUrl || "",
              client: clientData
            }).smsBody
          })}
        />
      )}

      {showFingerPrintPanel && (
        <FingerprintEnrollPanel
          onClose={() => setShowFingerPrintPanel(false)}
          clientId={clientData.id}
        />
      )}

      {estimatePanel.show && (
        <EstimatesCreateEdit
          editMode={isEditMode}
          selectedEstimate={estimatePanel.data}
          onClose={() => {
            setEstimatePanel({ data: null, show: false });
            setIsEditMode(false);
          }}
          selectedClient={clientData}
          afterSave={(value) => {
            setEstimatePanel({ data: value, show: false });
            setIsEditMode(false);
            dispatch(fetchEstimatesByClient(clientData.id));
          }}
        />
      )}

      {estimatePanel.data && (
        <EstimateInfo
          data={estimatePanel.data}
          onClose={() => setEstimatePanel({ data: null, show: false })}
          setEditMode={() => {
            setEstimatePanel((prevState) => ({ ...prevState, show: true }));
            setIsEditMode(true);
          }}
        />
      )}

      {showActivityPanel && (
        <ClientActivity onClose={() => setShowActivityPanel(false)} client={clientData} />
      )}

      {consentForm.isOpen && (
        <ConsentCreateEditForm
          isEditMode={consentForm.isEditMode}
          data={consentForm.data}
          onClose={() => setConsentForm({ isOpen: false, isEditMode: false, data: null })}
          client={clientData}
          afterSave={(data) => {
            setConsentForm({ isOpen: false, isEditMode: false, data });
          }}
        />
      )}

      {consentForm.data && (
        <ConsentFormShow
          data={consentForm.data}
          onClose={() => setConsentForm({ isOpen: false, isEditMode: false, data: null })}
          onEdit={() => {
            setConsentForm((prev) => ({ ...prev, isOpen: true, isEditMode: true }));
          }}
        />
      )}

      {surveyForm.isOpen && (
        <SurveyCreateEditForm
          template={surveyTemplate}
          isEditMode={surveyForm.isEditMode}
          data={surveyForm.data}
          onClose={() => setSurveyForm({ isOpen: false, isEditMode: false, data: null })}
          client={clientData}
          afterSave={(data) => {
            setSurveyForm({ isOpen: false, isEditMode: false, data });
          }}
        />
      )}

      {surveyForm.data && (
        <SurveyFormShow
          data={surveyForm.data}
          onClose={() => setSurveyForm({ isOpen: false, isEditMode: false, data: null })}
          onEdit={() => {
            setSurveyForm((prev) => ({ ...prev, isOpen: true, isEditMode: true }));
          }}
        />
      )}

      {openFpRemoveDialog && (
        <OkhatiDialog
          title="Remove Fingerprint Data"
          description={`Do you really want to remove fingerprint data for ${clientFullNameSelector(
            clientData
          )} ?`}
          next={async () => {
            try {
              const res = await deleteFingerprintTemplateById(clientData.fingerprintTemplate!.id);
              await agentDelete(`/templates/${clientData.fingerprintTemplate!.id}/unload`);

              syncClient({
                clientId: clientData.id,
                toUpdateValue: null,
                toUpdateKey: "fingerprintTemplate"
              });
              dispatch(
                notificationAdd({
                  id: new Date().getUTCMilliseconds(),
                  variant: "success",
                  message: res?.message || "Operation successful!.",
                  autoTimeout: true
                })
              );
            } catch (err: any) {
              dispatch(
                notificationAdd({
                  id: new Date().getUTCMilliseconds(),
                  variant: "error",
                  message: err?.message || "Something Went Wrong!.",
                  autoTimeout: true
                })
              );
            } finally {
              setOpenFpRemoveDialog(false);
            }
          }}
          cancel={() => {
            setOpenFpRemoveDialog(false);
          }}
          readMode={false}
        />
      )}
    </>
  );
};

interface MapStateToProps {
  permissionGroup: string;
  clientVisits: Array<ClientVisit>;
  clientData: Partial<Client>;
  user: IUser & { role: string };
  restrictTestCreation: boolean;
}

interface MapDispatchToProps {
  getClientVisits: (id: number) => void;
  navigateTo: (string) => void;
  loadFullClient: (number) => void;
  onDeleteClient: (id: number, clientName: string, searchQuery: string) => void;
  postVitals: (data: Record<string, unknown>, clientId: number) => void;
  getVitals: (number) => void;
}

interface OwnProps {
  clientData?: Client;
  handleViewClose: () => void;
  wrapperStyle?: Record<string, unknown>;
  setEditMode?: (v: boolean) => void;
  stayOnCurrentPage?: boolean;
  id: number;
  messageTemplateType?: MessageTemplateEnum;
  labResultUrl?: string;
}

export default connect<MapStateToProps, MapDispatchToProps, OwnProps>(
  ({ userContext, clients, resources }: RootState, { id }) => {
    const resourceCentre =
      resources.resourceCentres.find((rc) => rc.id === userContext.resourceCentreId) ||
      userContext.resourceCentre;

    const restrictTestCreation = resourceCentre?.labSettings?.enableTestCreationFromBillOnly;
    return {
      permissionGroup: userContext.userCreds?.userGroups[0],

      clientVisits: clients.visits.filter(({ clientId }) => clientId === id),
      clientData: clients.collection?.find((c) => c.id === id),
      user: { ...userContext.user, role: userContext.mode },
      restrictTestCreation
    };
  },
  (dispatch: IThunkDispatch) => ({
    getClientVisits: (id: number) => dispatch(clientActions.getClientVisits(id)),
    navigateTo: (url) => dispatch(push(url)),
    loadFullClient: (id) => dispatch(clientActions.getClientById(id)),
    onDeleteClient: (id, clientName, searchQuery) => {
      dispatch(
        showDialog({
          title: "Delete customer",
          description: `Are you sure you want to delete ${clientName}?`,
          next: () => {
            dispatch(deleteClient(id));
            dispatch(navigateRemoveModal("Dialog"));
            dispatch(push(`/clients${searchQuery}`));
          },
          onCancel: () => dispatch(navigateRemoveModal)
        })
      );
    },
    postVitals: (data, clientId) => dispatch(VitalActions.postVitals(data, clientId)),
    getVitals: (clientId) => dispatch(VitalActions.getVitalsById(clientId))
  })
)(ClientInfo);
